/**
 * SEO-Konfiguration: Städte (slug → DE/EN Inhalte) + optionale Stadtviertel.
 * 18 ausgewählte DACH-Städte mit echtem Such-Volumen für Restaurant-Queries.
 *
 * Jede Stadt hat ein `districts`-Array (2-6 Viertel) für die noch granulareren
 * /:style/:city/:district SEO-Landingpages.
 */
export const SEO_CITIES = [
  {
    slug: "berlin",
    nameDe: "Berlin",
    nameEn: "Berlin",
    region: "Berlin",
    country: "DE",
    localHookDe:
      "Von Friedrichshain bis Charlottenburg: Berlin gehört zu den vielfältigsten Food-Szenen Europas — Feaststar zeigt, was sich wirklich lohnt.",
    localHookEn:
      "From Friedrichshain to Charlottenburg: Berlin has one of Europe's most diverse food scenes — Feaststar shows what's truly worth it.",
    districts: [
      { slug: "mitte", nameDe: "Mitte", nameEn: "Mitte", hookDe: "Berlin-Mitte verbindet Touristen-Klassik mit hochwertiger zeitgenössischer Küche — Feaststar zeigt, wo Qualität schlägt Lage.", hookEn: "Berlin-Mitte mixes tourist classics with high-quality contemporary cuisine — Feaststar shows where quality beats location." },
      { slug: "friedrichshain", nameDe: "Friedrichshain", nameEn: "Friedrichshain", hookDe: "Friedrichshain ist Berlins junge Food-Bühne — Feaststar trennt Hype von echter handwerklicher Qualität.", hookEn: "Friedrichshain is Berlin's young food stage — Feaststar separates hype from real artisan quality." },
      { slug: "kreuzberg", nameDe: "Kreuzberg", nameEn: "Kreuzberg", hookDe: "Kreuzberg verbindet internationale Küchen mit Berliner Identität — Feaststar zeigt, welche Adressen halten, was sie versprechen.", hookEn: "Kreuzberg blends international cuisines with Berlin identity — Feaststar shows which addresses keep their promise." },
      { slug: "prenzlauer-berg", nameDe: "Prenzlauer Berg", nameEn: "Prenzlauer Berg", hookDe: "Prenzlauer Berg steht für bewusste Familien und gehobenen Anspruch — Feaststar findet die Bio- und Familien-Adressen.", hookEn: "Prenzlauer Berg stands for mindful families and elevated expectations — Feaststar finds the organic and family-friendly places." },
      { slug: "charlottenburg", nameDe: "Charlottenburg", nameEn: "Charlottenburg", hookDe: "Charlottenburg vereint klassische Eleganz mit moderner Esskultur — Feaststar zeigt die handverlesenen Adressen.", hookEn: "Charlottenburg blends classic elegance with modern food culture — Feaststar shows the handpicked addresses." },
      { slug: "schoeneberg", nameDe: "Schöneberg", nameEn: "Schöneberg", hookDe: "Schöneberg ist Berlins gemütliche Seite mit Wochenmärkten und kleinen Manufakturen — Feaststar macht sie sichtbar.", hookEn: "Schöneberg is Berlin's cozy side with weekly markets and small producers — Feaststar makes them visible." },
    ],
  },
  {
    slug: "hamburg",
    nameDe: "Hamburg",
    nameEn: "Hamburg",
    region: "Hamburg",
    country: "DE",
    localHookDe:
      "Von Eppendorf bis Schanze: Hamburg verbindet maritime Frische mit handwerklicher Küche — Feaststar filtert die ehrlichen Adressen heraus.",
    localHookEn:
      "From Eppendorf to Schanze: Hamburg combines maritime freshness with artisan cuisine — Feaststar filters the honest addresses.",
    districts: [
      { slug: "schanze", nameDe: "Schanzenviertel", nameEn: "Schanzenviertel", hookDe: "Das Schanzenviertel ist Hamburgs kreatives Food-Labor — Feaststar zeigt, welche Konzepte mehr sind als Trend.", hookEn: "Schanzenviertel is Hamburg's creative food lab — Feaststar shows which concepts are more than trend." },
      { slug: "eppendorf", nameDe: "Eppendorf", nameEn: "Eppendorf", hookDe: "Eppendorf steht für gehobene Familien-Gastronomie mit Qualitätsanspruch — Feaststar findet die wirklich guten Adressen.", hookEn: "Eppendorf stands for elevated family gastronomy with quality standards — Feaststar finds the truly good places." },
      { slug: "eimsbuettel", nameDe: "Eimsbüttel", nameEn: "Eimsbüttel", hookDe: "Eimsbüttel kombiniert junge Cafés mit handwerklichen Bäckereien — Feaststar zeigt die echten Stärken.", hookEn: "Eimsbüttel combines young cafés with artisan bakeries — Feaststar shows the real strengths." },
      { slug: "st-pauli", nameDe: "St. Pauli", nameEn: "St. Pauli", hookDe: "St. Pauli ist roh, ehrlich und überraschend vielfältig — Feaststar findet die guten Konzepte hinter der Fassade.", hookEn: "St. Pauli is raw, honest and surprisingly diverse — Feaststar finds the good concepts behind the facade." },
    ],
  },
  {
    slug: "muenchen",
    nameDe: "München",
    nameEn: "Munich",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Von Glockenbach bis Schwabing: München steht für gehobene Esskultur — Feaststar zeigt, welche Betriebe ihre Standards wirklich leben.",
    localHookEn:
      "From Glockenbach to Schwabing: Munich stands for elevated food culture — Feaststar shows which places truly live their standards.",
    districts: [
      { slug: "glockenbachviertel", nameDe: "Glockenbachviertel", nameEn: "Glockenbachviertel", hookDe: "Das Glockenbachviertel ist Münchens lebendige Food-Bühne — Feaststar zeigt die echten Empfehlungen.", hookEn: "Glockenbachviertel is Munich's vibrant food stage — Feaststar shows the real recommendations." },
      { slug: "schwabing", nameDe: "Schwabing", nameEn: "Schwabing", hookDe: "Schwabing verbindet bohème mit Qualitätsanspruch — Feaststar filtert die Adressen mit echter Substanz.", hookEn: "Schwabing blends bohemian flair with quality standards — Feaststar filters places with real substance." },
      { slug: "maxvorstadt", nameDe: "Maxvorstadt", nameEn: "Maxvorstadt", hookDe: "Maxvorstadt ist Münchens studentisch-akademische Gegend mit überraschender Tiefe — Feaststar zeigt sie.", hookEn: "Maxvorstadt is Munich's student-academic area with surprising depth — Feaststar shows it." },
      { slug: "haidhausen", nameDe: "Haidhausen", nameEn: "Haidhausen", hookDe: "Haidhausen vereint französische Eleganz mit bayerischer Gemütlichkeit — Feaststar findet die Perlen.", hookEn: "Haidhausen blends French elegance with Bavarian coziness — Feaststar finds the gems." },
    ],
  },
  {
    slug: "koeln",
    nameDe: "Köln",
    nameEn: "Cologne",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe:
      "Vom Belgischen Viertel bis Ehrenfeld: Köln bietet eine wachsende Szene bewusster Gastronomie — Feaststar macht sie sichtbar.",
    localHookEn:
      "From Belgisches Viertel to Ehrenfeld: Cologne offers a growing scene of mindful gastronomy — Feaststar makes it visible.",
    districts: [
      { slug: "belgisches-viertel", nameDe: "Belgisches Viertel", nameEn: "Belgian Quarter", hookDe: "Das Belgische Viertel ist Kölns kreatives Zentrum — Feaststar zeigt, welche Cafés und Restaurants ihren Ruf rechtfertigen.", hookEn: "The Belgian Quarter is Cologne's creative core — Feaststar shows which cafés and restaurants justify their reputation." },
      { slug: "ehrenfeld", nameDe: "Ehrenfeld", nameEn: "Ehrenfeld", hookDe: "Ehrenfeld lebt vom kreativen Mix junger Konzepte — Feaststar findet die handwerklichen Schwergewichte.", hookEn: "Ehrenfeld thrives on a creative mix of young concepts — Feaststar finds the artisan heavyweights." },
      { slug: "suedstadt", nameDe: "Südstadt", nameEn: "Südstadt", hookDe: "Die Südstadt vereint Familien-Gastronomie mit handwerklichen Manufakturen — Feaststar macht sie sichtbar.", hookEn: "Südstadt combines family gastronomy with artisan producers — Feaststar makes them visible." },
    ],
  },
  {
    slug: "frankfurt",
    nameDe: "Frankfurt",
    nameEn: "Frankfurt",
    region: "Hessen",
    country: "DE",
    localHookDe:
      "Vom Westend bis Bornheim: Frankfurts internationale Food-Szene trifft auf hessische Tradition — Feaststar zeigt, was Qualität bedeutet.",
    localHookEn:
      "From Westend to Bornheim: Frankfurt's international food scene meets Hessian tradition — Feaststar shows what quality means.",
    districts: [
      { slug: "westend", nameDe: "Westend", nameEn: "Westend", hookDe: "Das Westend steht für gehobenes Frankfurt — Feaststar findet die Adressen mit echter Substanz statt Status.", hookEn: "The Westend stands for upscale Frankfurt — Feaststar finds places with real substance, not status." },
      { slug: "bornheim", nameDe: "Bornheim", nameEn: "Bornheim", hookDe: "Bornheim ist Frankfurts ehrliche, lebendige Food-Szene — Feaststar zeigt die handwerklichen Perlen.", hookEn: "Bornheim is Frankfurt's honest, lively food scene — Feaststar shows the artisan gems." },
      { slug: "sachsenhausen", nameDe: "Sachsenhausen", nameEn: "Sachsenhausen", hookDe: "Sachsenhausen verbindet Tradition mit moderner Karte — Feaststar trennt Klischee von Qualität.", hookEn: "Sachsenhausen blends tradition with modern menus — Feaststar separates cliché from quality." },
    ],
  },
  {
    slug: "stuttgart",
    nameDe: "Stuttgart",
    nameEn: "Stuttgart",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe:
      "Von West bis Bohnenviertel: Stuttgart vereint schwäbische Wurzeln mit moderner Küche — Feaststar zeigt die Adressen, die beides können.",
    localHookEn:
      "From West to Bohnenviertel: Stuttgart blends Swabian roots with modern cuisine — Feaststar shows the places that do both.",
    districts: [
      { slug: "stuttgart-west", nameDe: "Stuttgart-West", nameEn: "Stuttgart-West", hookDe: "Stuttgart-West ist die hippe junge Seite — Feaststar zeigt die Cafés und Restaurants mit Substanz.", hookEn: "Stuttgart-West is the hip young side — Feaststar shows cafés and restaurants with substance." },
      { slug: "bohnenviertel", nameDe: "Bohnenviertel", nameEn: "Bohnenviertel", hookDe: "Das Bohnenviertel ist Stuttgarts charmantes Quartier mit handwerklicher Gastronomie — Feaststar macht sie sichtbar.", hookEn: "Bohnenviertel is Stuttgart's charming quarter with artisan gastronomy — Feaststar makes it visible." },
    ],
  },
  {
    slug: "duesseldorf",
    nameDe: "Düsseldorf",
    nameEn: "Düsseldorf",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe:
      "Von Pempelfort bis Flingern: Düsseldorf verbindet japanische Tradition mit rheinischer Genusskultur — Feaststar bringt Klarheit in die Auswahl.",
    localHookEn:
      "From Pempelfort to Flingern: Düsseldorf blends Japanese tradition with Rhenish food culture — Feaststar brings clarity to the choice.",
    districts: [
      { slug: "pempelfort", nameDe: "Pempelfort", nameEn: "Pempelfort", hookDe: "Pempelfort ist Düsseldorfs Food-Hotspot mit junger Energie — Feaststar zeigt die echten Empfehlungen.", hookEn: "Pempelfort is Düsseldorf's food hotspot with young energy — Feaststar shows the real recommendations." },
      { slug: "flingern", nameDe: "Flingern", nameEn: "Flingern", hookDe: "Flingern verbindet Industrie-Charme mit kreativer Küche — Feaststar findet die echten Stärken.", hookEn: "Flingern blends industrial charm with creative cuisine — Feaststar finds the real strengths." },
      { slug: "friedrichstadt", nameDe: "Friedrichstadt", nameEn: "Friedrichstadt", hookDe: "Friedrichstadt vereint Eleganz mit moderner Esskultur — Feaststar zeigt die handverlesenen Adressen.", hookEn: "Friedrichstadt blends elegance with modern food culture — Feaststar shows the handpicked addresses." },
    ],
  },
  {
    slug: "leipzig",
    nameDe: "Leipzig",
    nameEn: "Leipzig",
    region: "Sachsen",
    country: "DE",
    localHookDe:
      "Vom Süden bis Plagwitz: Leipzig hat sich zu einer der spannendsten Food-Städte Ostdeutschlands entwickelt — Feaststar zeigt, wo sich Qualität versteckt.",
    localHookEn:
      "From the south to Plagwitz: Leipzig has grown into one of eastern Germany's most exciting food cities — Feaststar shows where quality hides.",
    districts: [
      { slug: "suedvorstadt", nameDe: "Südvorstadt", nameEn: "Südvorstadt", hookDe: "Die Südvorstadt (rund um die Karli) ist Leipzigs lebendigste Food-Szene — Feaststar zeigt die echten Empfehlungen.", hookEn: "Südvorstadt (around the Karli) is Leipzig's most vibrant food scene — Feaststar shows the real recommendations." },
      { slug: "plagwitz", nameDe: "Plagwitz", nameEn: "Plagwitz", hookDe: "Plagwitz lebt vom kreativen Mix junger Konzepte — Feaststar findet die handwerklichen Schwergewichte.", hookEn: "Plagwitz thrives on a creative mix of young concepts — Feaststar finds the artisan heavyweights." },
      { slug: "connewitz", nameDe: "Connewitz", nameEn: "Connewitz", hookDe: "Connewitz steht für alternative Esskultur mit Substanz — Feaststar macht die guten Adressen sichtbar.", hookEn: "Connewitz stands for alternative food culture with substance — Feaststar makes the good addresses visible." },
    ],
  },
  {
    slug: "dresden",
    nameDe: "Dresden",
    nameEn: "Dresden",
    region: "Sachsen",
    country: "DE",
    localHookDe:
      "Von der Neustadt bis zur Innenstadt: Dresden steht für handwerkliche Küche mit regionalem Bezug — Feaststar macht die echten Adressen sichtbar.",
    localHookEn:
      "From Neustadt to the city center: Dresden stands for artisan cuisine with regional ties — Feaststar makes the real addresses visible.",
    districts: [
      { slug: "neustadt", nameDe: "Neustadt", nameEn: "Neustadt", hookDe: "Die Dresdner Neustadt ist die kreative Food-Bühne der Stadt — Feaststar zeigt, was wirklich überzeugt.", hookEn: "Dresden Neustadt is the city's creative food stage — Feaststar shows what truly convinces." },
      { slug: "innere-altstadt", nameDe: "Innere Altstadt", nameEn: "Inner Old Town", hookDe: "Die Innere Altstadt vereint Tradition mit modernen Konzepten — Feaststar findet die Adressen mit echter Qualität.", hookEn: "Dresden's Inner Old Town blends tradition with modern concepts — Feaststar finds places with real quality." },
    ],
  },
  {
    slug: "hannover",
    nameDe: "Hannover",
    nameEn: "Hanover",
    region: "Niedersachsen",
    country: "DE",
    localHookDe:
      "Von Linden bis List: Hannover bietet eine unterschätzte Food-Szene mit ehrlichem Handwerk — Feaststar zeigt, was sich lohnt.",
    localHookEn:
      "From Linden to List: Hanover offers an underrated food scene with honest craftsmanship — Feaststar shows what's worth it.",
    districts: [
      { slug: "linden", nameDe: "Linden", nameEn: "Linden", hookDe: "Linden ist Hannovers lebendige Food-Bühne mit kreativer Küche — Feaststar zeigt die echten Empfehlungen.", hookEn: "Linden is Hanover's lively food stage with creative cuisine — Feaststar shows the real recommendations." },
      { slug: "list", nameDe: "List", nameEn: "List", hookDe: "Die List verbindet gehobene Gastronomie mit ehrlichem Handwerk — Feaststar findet die Adressen mit Substanz.", hookEn: "List blends upscale gastronomy with honest craft — Feaststar finds places with substance." },
    ],
  },
  {
    slug: "nuernberg",
    nameDe: "Nürnberg",
    nameEn: "Nuremberg",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Von der Altstadt bis Gostenhof: Nürnberg verbindet fränkische Tradition mit moderner Esskultur — Feaststar filtert die echten Spitzen.",
    localHookEn:
      "From the old town to Gostenhof: Nuremberg blends Franconian tradition with modern food culture — Feaststar filters the real highlights.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Nürnberger Altstadt vereint Tradition mit modernen Konzepten — Feaststar zeigt die Adressen mit echter Qualität.", hookEn: "Nuremberg's Old Town blends tradition with modern concepts — Feaststar shows places with real quality." },
      { slug: "gostenhof", nameDe: "Gostenhof", nameEn: "Gostenhof", hookDe: "Gostenhof ist Nürnbergs junge, kreative Food-Szene — Feaststar findet die handwerklichen Spitzen.", hookEn: "Gostenhof is Nuremberg's young, creative food scene — Feaststar finds the artisan highlights." },
    ],
  },
  {
    slug: "bremen",
    nameDe: "Bremen",
    nameEn: "Bremen",
    region: "Bremen",
    country: "DE",
    localHookDe:
      "Vom Viertel bis Findorff: Bremen bietet eine ruhige, qualitätsbewusste Food-Szene — Feaststar zeigt, wer wirklich gut arbeitet.",
    localHookEn:
      "From the Viertel to Findorff: Bremen offers a calm, quality-conscious food scene — Feaststar shows who really delivers.",
    districts: [
      { slug: "das-viertel", nameDe: "Das Viertel", nameEn: "Das Viertel", hookDe: "Das Viertel ist Bremens lebendige Food-Szene mit kreativen Konzepten — Feaststar zeigt die echten Empfehlungen.", hookEn: "Das Viertel is Bremen's lively food scene with creative concepts — Feaststar shows the real recommendations." },
      { slug: "findorff", nameDe: "Findorff", nameEn: "Findorff", hookDe: "Findorff steht für ruhige, qualitätsbewusste Gastronomie — Feaststar findet die handwerklichen Adressen.", hookEn: "Findorff stands for calm, quality-conscious gastronomy — Feaststar finds the artisan addresses." },
    ],
  },
  {
    slug: "muenster",
    nameDe: "Münster",
    nameEn: "Münster",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe:
      "Vom Kreuzviertel bis zur Innenstadt: Münster lebt von kurzen Wegen zu regionalen Höfen — Feaststar macht das sichtbar.",
    localHookEn:
      "From Kreuzviertel to the center: Münster thrives on short routes to regional farms — Feaststar makes that visible.",
    districts: [
      { slug: "kreuzviertel", nameDe: "Kreuzviertel", nameEn: "Kreuzviertel", hookDe: "Das Kreuzviertel ist Münsters kreative Food-Bühne — Feaststar zeigt die handverlesenen Adressen.", hookEn: "Kreuzviertel is Münster's creative food stage — Feaststar shows the handpicked addresses." },
      { slug: "hafenviertel", nameDe: "Hafenviertel", nameEn: "Hafenviertel", hookDe: "Das Hafenviertel verbindet Industrie-Charme mit moderner Gastronomie — Feaststar findet die echten Stärken.", hookEn: "Hafenviertel blends industrial charm with modern gastronomy — Feaststar finds the real strengths." },
    ],
  },
  {
    slug: "freiburg",
    nameDe: "Freiburg",
    nameEn: "Freiburg",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe:
      "Von der Altstadt bis Vauban: Freiburg ist eine der nachhaltigsten Food-Städte Deutschlands — Feaststar zeigt die Standards dahinter.",
    localHookEn:
      "From the old town to Vauban: Freiburg is one of Germany's most sustainable food cities — Feaststar shows the standards behind it.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Freiburger Altstadt vereint Bio-Tradition mit modernen Konzepten — Feaststar zeigt die echten Standards.", hookEn: "Freiburg's Old Town blends organic tradition with modern concepts — Feaststar shows the real standards." },
      { slug: "vauban", nameDe: "Vauban", nameEn: "Vauban", hookDe: "Vauban ist Deutschlands nachhaltigstes Quartier — Feaststar findet die Gastronomie, die diesen Anspruch lebt.", hookEn: "Vauban is Germany's most sustainable district — Feaststar finds gastronomy that lives up to that bar." },
    ],
  },
  {
    slug: "heidelberg",
    nameDe: "Heidelberg",
    nameEn: "Heidelberg",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe:
      "Von der Altstadt bis Bergheim: Heidelberg verbindet akademische Vielfalt mit regionaler Küche — Feaststar zeigt, welche Adressen halten, was sie versprechen.",
    localHookEn:
      "From the old town to Bergheim: Heidelberg blends academic diversity with regional cuisine — Feaststar shows which addresses keep their promise.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Heidelberger Altstadt vereint Tradition mit moderner Karte — Feaststar zeigt die Adressen mit Substanz.", hookEn: "Heidelberg's Old Town blends tradition with modern menus — Feaststar shows places with substance." },
      { slug: "bergheim", nameDe: "Bergheim", nameEn: "Bergheim", hookDe: "Bergheim ist Heidelbergs junge, lebendige Seite — Feaststar findet die kreativen Konzepte mit Qualität.", hookEn: "Bergheim is Heidelberg's young, lively side — Feaststar finds creative concepts with quality." },
    ],
  },
  {
    slug: "wien",
    nameDe: "Wien",
    nameEn: "Vienna",
    region: "Wien",
    country: "AT",
    localHookDe:
      "Vom 7. Bezirk bis Hietzing: Wien lebt seine Kaffeehauskultur — und zunehmend eine bewusste Food-Szene. Feaststar zeigt, wo Qualität wirklich zu finden ist.",
    localHookEn:
      "From the 7th district to Hietzing: Vienna lives its coffeehouse culture — and increasingly a mindful food scene. Feaststar shows where to find real quality.",
    districts: [
      { slug: "neubau", nameDe: "Neubau (7. Bezirk)", nameEn: "Neubau (7th district)", hookDe: "Der 7. Bezirk ist Wiens kreative Food-Bühne — Feaststar zeigt die handverlesenen Adressen.", hookEn: "The 7th district is Vienna's creative food stage — Feaststar shows the handpicked addresses." },
      { slug: "josefstadt", nameDe: "Josefstadt (8. Bezirk)", nameEn: "Josefstadt (8th district)", hookDe: "Die Josefstadt verbindet bürgerliche Eleganz mit moderner Esskultur — Feaststar findet die Adressen mit Tiefe.", hookEn: "Josefstadt blends bourgeois elegance with modern food culture — Feaststar finds places with depth." },
      { slug: "leopoldstadt", nameDe: "Leopoldstadt", nameEn: "Leopoldstadt", hookDe: "Leopoldstadt ist die multikulturelle Seite Wiens — Feaststar zeigt die ehrlichen Konzepte hinter dem Trend.", hookEn: "Leopoldstadt is Vienna's multicultural side — Feaststar shows the honest concepts behind the trend." },
      { slug: "hietzing", nameDe: "Hietzing", nameEn: "Hietzing", hookDe: "Hietzing steht für gehobene, ruhige Gastronomie — Feaststar findet die Adressen mit echter Qualität.", hookEn: "Hietzing stands for upscale, quiet gastronomy — Feaststar finds places with real quality." },
    ],
  },
  {
    slug: "salzburg",
    nameDe: "Salzburg",
    nameEn: "Salzburg",
    region: "Salzburg",
    country: "AT",
    localHookDe:
      "Von der Altstadt bis Lehen: Salzburg verbindet alpine Tradition mit moderner Bio-Küche — Feaststar zeigt die handverlesenen Adressen.",
    localHookEn:
      "From the old town to Lehen: Salzburg blends alpine tradition with modern organic cuisine — Feaststar shows the handpicked addresses.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Salzburger Altstadt vereint Tradition mit moderner Karte — Feaststar zeigt die Adressen mit echter Qualität.", hookEn: "Salzburg's Old Town blends tradition with modern menus — Feaststar shows places with real quality." },
      { slug: "lehen", nameDe: "Lehen", nameEn: "Lehen", hookDe: "Lehen ist Salzburgs junge, lebendige Food-Szene — Feaststar findet die kreativen Konzepte mit Substanz.", hookEn: "Lehen is Salzburg's young, lively food scene — Feaststar finds creative concepts with substance." },
    ],
  },
  {
    slug: "zuerich",
    nameDe: "Zürich",
    nameEn: "Zurich",
    region: "Zürich",
    country: "CH",
    localHookDe:
      "Vom Kreis 4 bis zum Seefeld: Zürich verbindet Schweizer Qualitätsanspruch mit internationaler Vielfalt — Feaststar zeigt, was diesen Anspruch wirklich erfüllt.",
    localHookEn:
      "From district 4 to Seefeld: Zurich blends Swiss quality expectations with international diversity — Feaststar shows what truly meets that bar.",
    districts: [
      { slug: "kreis-4", nameDe: "Kreis 4", nameEn: "District 4", hookDe: "Der Kreis 4 ist Zürichs lebendigste Food-Szene — Feaststar zeigt die echten Empfehlungen jenseits des Trends.", hookEn: "District 4 is Zurich's most vibrant food scene — Feaststar shows the real recommendations beyond the trend." },
      { slug: "seefeld", nameDe: "Seefeld", nameEn: "Seefeld", hookDe: "Seefeld steht für gehobene, ruhige Esskultur — Feaststar findet die Adressen mit echter Substanz.", hookEn: "Seefeld stands for upscale, quiet dining — Feaststar finds places with real substance." },
      { slug: "niederdorf", nameDe: "Niederdorf", nameEn: "Niederdorf", hookDe: "Das Niederdorf vereint Altstadt-Charme mit modernen Konzepten — Feaststar zeigt die Adressen mit Qualität.", hookEn: "Niederdorf blends old-town charm with modern concepts — Feaststar shows the places with quality." },
    ],
  },
  // =========================
  // Allgäu-Cluster (Süd-Bayern / Baden-Württemberg)
  // Kleinere Städte mit hoher Suchrelevanz für regional-bewusste Ernährung,
  // insbesondere Bio, Demeter, Bioland (Allgäu ist Bio-Kernregion Deutschlands).
  // =========================
  {
    slug: "legau",
    nameDe: "Legau",
    nameEn: "Legau",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Legau im Unterallgäu ist Heimat von Milchmanufakturen, Bio-Höfen und regionaler Handwerkskultur — Feaststar zeigt, wo diese Qualität aufgetischt wird.",
    localHookEn:
      "Legau in the Unterallgäu is home to dairy manufacturers, organic farms and regional craftsmanship — Feaststar shows where this quality is served.",
    districts: [],
  },
  {
    slug: "memmingen",
    nameDe: "Memmingen",
    nameEn: "Memmingen",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Memmingen verbindet schwäbische Wirtshaustradition mit einer wachsenden bewussten Food-Szene im Herzen des Allgäus — Feaststar filtert die ehrlichen Adressen.",
    localHookEn:
      "Memmingen blends Swabian inn tradition with a growing mindful food scene in the heart of the Allgäu — Feaststar filters the honest addresses.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Memminger Altstadt vereint historische Wirtshäuser mit modernen Konzepten — Feaststar zeigt die Adressen mit echter Qualität.", hookEn: "Memmingen's Old Town blends historic inns with modern concepts — Feaststar shows places with real quality." },
    ],
  },
  {
    slug: "kempten",
    nameDe: "Kempten",
    nameEn: "Kempten",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Kempten ist die heimliche Hauptstadt des Allgäus — mit Bio-Manufakturen, Wochenmärkten und einer wachsenden regionalen Gastronomieszene. Feaststar zeigt die echten Spitzen.",
    localHookEn:
      "Kempten is the secret capital of the Allgäu — with organic manufacturers, weekly markets and a growing regional gastronomy scene. Feaststar shows the real highlights.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Kemptener Altstadt vereint alpine Tradition mit moderner Bio-Küche — Feaststar findet die handverlesenen Adressen.", hookEn: "Kempten's Old Town blends alpine tradition with modern organic cuisine — Feaststar finds the handpicked addresses." },
    ],
  },
  {
    slug: "leutkirch",
    nameDe: "Leutkirch",
    nameEn: "Leutkirch",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe:
      "Leutkirch im Württembergischen Allgäu steht für Bio-Landwirtschaft, Demeter-Höfe und ehrliches Handwerk — Feaststar macht die guten Adressen sichtbar.",
    localHookEn:
      "Leutkirch in the Württemberg Allgäu stands for organic farming, Demeter farms and honest craft — Feaststar makes the good addresses visible.",
    districts: [],
  },
  // =========================
  // Lindau am Bodensee (angrenzend zum Allgäu)
  // =========================
  {
    slug: "lindau",
    nameDe: "Lindau",
    nameEn: "Lindau",
    region: "Bayern",
    country: "DE",
    localHookDe:
      "Lindau am Bodensee verbindet mediterranes Flair mit regionaler Küche vom See und aus dem Allgäu — Feaststar zeigt die Adressen mit Substanz jenseits der Touristenpfade.",
    localHookEn:
      "Lindau on Lake Constance blends Mediterranean flair with regional cuisine from the lake and the Allgäu — Feaststar shows places with substance beyond the tourist trail.",
    districts: [
      { slug: "insel", nameDe: "Insel Lindau", nameEn: "Lindau Island", hookDe: "Die Insel Lindau vereint Bodensee-Flair mit regionaler Küche — Feaststar findet die Adressen mit echter Qualität.", hookEn: "Lindau Island blends Lake Constance flair with regional cuisine — Feaststar finds places with real quality." },
    ],
  },
  // =========================
  // Bayern (Metropolen & Regional-Zentren)
  // =========================
  {
    slug: "augsburg",
    nameDe: "Augsburg",
    nameEn: "Augsburg",
    region: "Bayern",
    country: "DE",
    localHookDe: "Augsburg verbindet Renaissance-Erbe mit einer wachsenden bewussten Food-Szene — Feaststar zeigt die Adressen, die schwäbische Wurzeln mit moderner Qualität verbinden.",
    localHookEn: "Augsburg blends Renaissance heritage with a growing mindful food scene — Feaststar shows places that combine Swabian roots with modern quality.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Augsburger Altstadt vereint Fugger-Tradition mit modernen Konzepten — Feaststar findet die handverlesenen Adressen.", hookEn: "Augsburg's Old Town blends Fugger tradition with modern concepts — Feaststar finds the handpicked places." },
    ],
  },
  {
    slug: "regensburg",
    nameDe: "Regensburg",
    nameEn: "Regensburg",
    region: "Bayern",
    country: "DE",
    localHookDe: "Regensburg vereint UNESCO-Altstadt mit lebendiger Studenten-Food-Szene — Feaststar zeigt die Adressen mit echter Substanz jenseits der Touristenmeile.",
    localHookEn: "Regensburg blends UNESCO old town with a vibrant student food scene — Feaststar shows places with real substance beyond the tourist strip.",
    districts: [
      { slug: "altstadt", nameDe: "Altstadt", nameEn: "Old Town", hookDe: "Die Regensburger Altstadt ist eine der best erhaltenen mittelalterlichen Städte Europas — Feaststar findet die ehrlichen kulinarischen Perlen.", hookEn: "Regensburg's Old Town is one of Europe's best-preserved medieval cities — Feaststar finds the honest culinary gems." },
    ],
  },
  {
    slug: "wuerzburg",
    nameDe: "Würzburg",
    nameEn: "Würzburg",
    region: "Bayern",
    country: "DE",
    localHookDe: "Würzburg lebt zwischen Barockresidenz und Weinbergen — Feaststar zeigt die fränkischen Wirtshäuser und modernen Konzepte mit echtem Handwerk.",
    localHookEn: "Würzburg lives between baroque residence and vineyards — Feaststar shows the Franconian inns and modern concepts with true craft.",
    districts: [],
  },
  {
    slug: "ingolstadt",
    nameDe: "Ingolstadt",
    nameEn: "Ingolstadt",
    region: "Bayern",
    country: "DE",
    localHookDe: "Ingolstadt vereint bayerische Wirtshaustradition mit einer wachsenden bewussten Gastronomie — Feaststar zeigt die Adressen mit Qualitätsanspruch.",
    localHookEn: "Ingolstadt blends Bavarian inn tradition with a growing mindful food scene — Feaststar shows the places with quality standards.",
    districts: [],
  },
  {
    slug: "fuerth",
    nameDe: "Fürth",
    nameEn: "Fürth",
    region: "Bayern",
    country: "DE",
    localHookDe: "Fürth ist Nürnbergs charmante Nachbarin mit eigener Food-Identität — Feaststar findet die handwerklichen Manufakturen und Cafés mit Substanz.",
    localHookEn: "Fürth is Nuremberg's charming neighbor with its own food identity — Feaststar finds the artisan producers and cafés with substance.",
    districts: [],
  },
  {
    slug: "erlangen",
    nameDe: "Erlangen",
    nameEn: "Erlangen",
    region: "Bayern",
    country: "DE",
    localHookDe: "Erlangen ist eine Universitätsstadt mit hoher Dichte bewusster Esser — Feaststar zeigt die Bio-Cafés, glutenfreien Bäckereien und regionalen Adressen.",
    localHookEn: "Erlangen is a university town with a high density of mindful eaters — Feaststar shows the organic cafés, gluten-free bakeries and regional places.",
    districts: [],
  },
  {
    slug: "bayreuth",
    nameDe: "Bayreuth",
    nameEn: "Bayreuth",
    region: "Bayern",
    country: "DE",
    localHookDe: "Bayreuth verbindet Wagner-Festspiele mit oberfränkischer Küche und wachsender bewusster Gastronomie — Feaststar findet die echten Empfehlungen.",
    localHookEn: "Bayreuth blends Wagner festivals with Upper Franconian cuisine and a growing mindful gastronomy — Feaststar finds the real recommendations.",
    districts: [],
  },
  {
    slug: "landshut",
    nameDe: "Landshut",
    nameEn: "Landshut",
    region: "Bayern",
    country: "DE",
    localHookDe: "Landshut vereint mittelalterliches Flair mit niederbayerischer Wirtshauskultur — Feaststar zeigt, wo Tradition auf moderne Qualität trifft.",
    localHookEn: "Landshut blends medieval flair with Lower Bavarian inn culture — Feaststar shows where tradition meets modern quality.",
    districts: [],
  },
  {
    slug: "bamberg",
    nameDe: "Bamberg",
    nameEn: "Bamberg",
    region: "Bayern",
    country: "DE",
    localHookDe: "Bamberg ist UNESCO-Welterbe und Bierstadt mit fränkischer Wirtshaustradition — Feaststar zeigt die Adressen mit ehrlichem Handwerk und Qualität.",
    localHookEn: "Bamberg is a UNESCO World Heritage and beer city with Franconian inn tradition — Feaststar shows places with honest craft and quality.",
    districts: [],
  },
  {
    slug: "passau",
    nameDe: "Passau",
    nameEn: "Passau",
    region: "Bayern",
    country: "DE",
    localHookDe: "Passau liegt am Zusammenfluss von Donau, Inn und Ilz — Feaststar zeigt die kulinarische Schnittstelle zwischen Bayern und Österreich mit echter Substanz.",
    localHookEn: "Passau sits at the confluence of Danube, Inn and Ilz — Feaststar shows the culinary interface between Bavaria and Austria with real substance.",
    districts: [],
  },
  {
    slug: "rosenheim",
    nameDe: "Rosenheim",
    nameEn: "Rosenheim",
    region: "Bayern",
    country: "DE",
    localHookDe: "Rosenheim ist das Tor zum Chiemgau — Bio-Höfe, Wirtshaustradition und moderne Konzepte in dichter Nähe. Feaststar findet die Adressen mit Substanz.",
    localHookEn: "Rosenheim is the gateway to the Chiemgau — organic farms, inn tradition and modern concepts in close proximity. Feaststar finds the substantial addresses.",
    districts: [],
  },
  {
    slug: "aschaffenburg",
    nameDe: "Aschaffenburg",
    nameEn: "Aschaffenburg",
    region: "Bayern",
    country: "DE",
    localHookDe: "Aschaffenburg verbindet unterfränkische Küche mit hessischer Nähe — Feaststar zeigt die Adressen mit ehrlichem Handwerk.",
    localHookEn: "Aschaffenburg blends Lower Franconian cuisine with proximity to Hesse — Feaststar shows the places with honest craft.",
    districts: [],
  },
  // =========================
  // Deutsche Großstädte >250k (Rest-DE Metropolen)
  // =========================
  {
    slug: "dortmund",
    nameDe: "Dortmund",
    nameEn: "Dortmund",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Dortmund transformiert sich vom Industrie-Erbe zur überraschend vielfältigen Food-Metropole — Feaststar zeigt die neuen Standards jenseits der Klischees.",
    localHookEn: "Dortmund transforms from industrial heritage to a surprisingly diverse food metropolis — Feaststar shows the new standards beyond clichés.",
    districts: [
      { slug: "kreuzviertel", nameDe: "Kreuzviertel", nameEn: "Kreuzviertel", hookDe: "Das Kreuzviertel ist Dortmunds junge, kreative Food-Szene — Feaststar zeigt die echten Empfehlungen.", hookEn: "Kreuzviertel is Dortmund's young, creative food scene — Feaststar shows the real recommendations." },
    ],
  },
  {
    slug: "essen",
    nameDe: "Essen",
    nameEn: "Essen",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Essen vereint Ruhrpott-Herz mit einer erstaunlich diversen Food-Szene rund um Zeche Zollverein und Rüttenscheid — Feaststar findet die substanziellen Adressen.",
    localHookEn: "Essen blends Ruhr heart with a surprisingly diverse food scene around Zeche Zollverein and Rüttenscheid — Feaststar finds the substantial addresses.",
    districts: [
      { slug: "ruettenscheid", nameDe: "Rüttenscheid", nameEn: "Rüttenscheid", hookDe: "Rüttenscheid ist Essens hippstes Food-Viertel — Feaststar zeigt die Adressen mit echter Qualität.", hookEn: "Rüttenscheid is Essen's hippest food district — Feaststar shows the places with real quality." },
    ],
  },
  {
    slug: "duisburg",
    nameDe: "Duisburg",
    nameEn: "Duisburg",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Duisburg zeigt kulinarische Vielfalt zwischen Rhein und Ruhr — Feaststar findet die ehrlichen Adressen in der unterschätzten Food-Szene.",
    localHookEn: "Duisburg shows culinary diversity between Rhine and Ruhr — Feaststar finds the honest addresses in this underrated food scene.",
    districts: [],
  },
  {
    slug: "bochum",
    nameDe: "Bochum",
    nameEn: "Bochum",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Bochum verbindet Uni-Energie mit kreativer Food-Szene rund um das Bermuda3Eck — Feaststar zeigt, was mehr ist als Party-Klischee.",
    localHookEn: "Bochum blends university energy with a creative food scene around Bermuda3Eck — Feaststar shows what's more than a party cliché.",
    districts: [],
  },
  {
    slug: "wuppertal",
    nameDe: "Wuppertal",
    nameEn: "Wuppertal",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Wuppertal überrascht mit kreativer Food-Szene unter der Schwebebahn — Feaststar findet die handwerklichen Cafés und Restaurants mit Substanz.",
    localHookEn: "Wuppertal surprises with a creative food scene beneath the suspension railway — Feaststar finds the artisan cafés and restaurants with substance.",
    districts: [],
  },
  {
    slug: "bielefeld",
    nameDe: "Bielefeld",
    nameEn: "Bielefeld",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Bielefeld hat sich zu einer ruhigen, qualitätsbewussten Food-Szene entwickelt — Feaststar zeigt die Adressen mit echtem Handwerk.",
    localHookEn: "Bielefeld has grown into a calm, quality-conscious food scene — Feaststar shows the addresses with real craft.",
    districts: [],
  },
  {
    slug: "bonn",
    nameDe: "Bonn",
    nameEn: "Bonn",
    region: "Nordrhein-Westfalen",
    country: "DE",
    localHookDe: "Bonn vereint diplomatische Ruhe mit rheinischer Küche und wachsender bewusster Gastronomie — Feaststar zeigt die Adressen mit Substanz.",
    localHookEn: "Bonn blends diplomatic calm with Rhenish cuisine and a growing mindful gastronomy — Feaststar shows the substantial places.",
    districts: [
      { slug: "poppelsdorf", nameDe: "Poppelsdorf", nameEn: "Poppelsdorf", hookDe: "Poppelsdorf ist Bonns lebendige Studentenszene mit vielfältigen Cafés — Feaststar zeigt die echten Empfehlungen.", hookEn: "Poppelsdorf is Bonn's vibrant student scene with diverse cafés — Feaststar shows the real recommendations." },
    ],
  },
  {
    slug: "karlsruhe",
    nameDe: "Karlsruhe",
    nameEn: "Karlsruhe",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe: "Karlsruhe verbindet badische Genussküche mit moderner Tech-Community — Feaststar zeigt die Adressen, in denen Handwerk und Innovation zusammenfinden.",
    localHookEn: "Karlsruhe blends Baden cuisine with a modern tech community — Feaststar shows places where craft meets innovation.",
    districts: [],
  },
  {
    slug: "mannheim",
    nameDe: "Mannheim",
    nameEn: "Mannheim",
    region: "Baden-Württemberg",
    country: "DE",
    localHookDe: "Mannheim ist die Quadratestadt mit multikultureller Food-Vielfalt — Feaststar findet die ehrlichen Adressen jenseits der Fast-Food-Ketten.",
    localHookEn: "Mannheim is the city of squares with multicultural food diversity — Feaststar finds the honest addresses beyond fast-food chains.",
    districts: [],
  },
  {
    slug: "wiesbaden",
    nameDe: "Wiesbaden",
    nameEn: "Wiesbaden",
    region: "Hessen",
    country: "DE",
    localHookDe: "Wiesbaden vereint Kurstadt-Eleganz mit moderner Genusskultur — Feaststar zeigt die Adressen mit gehobenem Qualitätsanspruch.",
    localHookEn: "Wiesbaden blends spa town elegance with modern food culture — Feaststar shows the places with elevated quality standards.",
    districts: [],
  },
];

export const SEO_CITY_MAP = Object.fromEntries(SEO_CITIES.map((c) => [c.slug, c]));
export const SEO_CITY_SLUGS = SEO_CITIES.map((c) => c.slug);

/** Lookup: city.slug → districts[] (empty array if none). */
export const SEO_DISTRICTS_BY_CITY = Object.fromEntries(
  SEO_CITIES.map((c) => [c.slug, c.districts || []]),
);

/** Lookup: city.slug → districtSlug → district object. */
export const SEO_DISTRICT_MAP = Object.fromEntries(
  SEO_CITIES.map((c) => [
    c.slug,
    Object.fromEntries((c.districts || []).map((d) => [d.slug, d])),
  ]),
);
